import { connect } from 'react-redux';
import {
	closeQuiz,
	addQuiz,
	updateQuiz,
} from '../actions/question';
import Errors from '../errors';
import {updateRecipe} from '../actions/recipe';
import CreateQuizModal from '../components/organisms/CreateQuizModal';


const mapStateToProps = ({recipeReducer,createQuiz,location}) => {
	const {content} = recipeReducer;
	const {recipes} = createQuiz;
	const {recipeId,quizId} = location.payload;
	const recipe = recipes.find(r=>r.id===recipeId);
	
	if(!recipe || !recipe.quizzes){
		return {
			show:false,
		};
	}
	const quiz = recipe.quizzes.find(q=>q.id===quizId);
	if(!quiz && quizId!=='create' && quizId){
		return {
			error:Errors.NotFoundQuiz,
			show:content.show,
		};
	}
	return {
		recipeId,
		quiz,
		show:content.show,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		onHide : ()=>{
			dispatch(closeQuiz());
		},
		onSave: (recipeId, quizId, content) =>{
			dispatch(updateQuiz(recipeId,quizId,content,()=>{
				dispatch((dispatch,getState)=>{
					const {location} = getState();
					const {recipeId} = location.payload;
					dispatch(updateRecipe({
						lastUpdate : Date.now()
					},recipeId));
				});
			}));
		},
		onSaveNew: (content) =>{
			dispatch(addQuiz({
				...content,
				checked:true,
				number : Date.now()
			},()=>{
				dispatch((dispatch,getState)=>{
					const {location} = getState();
					const {recipeId} = location.payload;
					dispatch(updateRecipe({
						lastUpdate : Date.now()
					},recipeId));
				});
			}));
		},
	};
};
export default connect(mapStateToProps,mapDispatchToProps)(CreateQuizModal);